export class CompanyEdit {
  id: number;
  code: string;
  name: string;
  isChecked: boolean;
}
